import * as React from 'react';
import { EditOutlined } from '@ant-design/icons';
import InvoicingSettingsModal from './components/Modal';

interface IInvoicingSettingsProps {
  order: GQL.IOrder;
  onUpdate: (data: any) => void;
}

interface IInvoicingSettingsState {
  modalOpened: boolean;
}

class InvoicingSettings extends React.Component<IInvoicingSettingsProps, IInvoicingSettingsState> {

  constructor(props: IInvoicingSettingsProps) {
    super(props);

    this.state = {
      modalOpened: false,
    };

    this.onToggleModal = this.onToggleModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  
  public render() {
    const { order } = this.props;

    return (
      <React.Fragment>
        <div className="editBlock invoicing" onClick={this.onToggleModal}>

          <div className="icon">
            <EditOutlined onClick={this.onToggleModal} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Invoice name</span>
            <span>{order.invoiceFirstName} {order.invoiceLastName}</span>
          </div>
          {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Street</span>
            <span>{order.invoiceStreet} {order.invoiceHouseNumber}</span>
          </div> */}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Street address</span>
            <span>{order.invoiceAddressLine1}</span>
          </div>
          {order.invoiceAddressLine2 &&
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <span style={{ color: '#999897' }}>Address line 2</span>
              <span>{order.invoiceAddressLine2}</span>
            </div>}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>City & Zip</span>
            <span>{order.invoiceCity}, {order.invoiceZip}</span>
          </div>
          {order.invoiceCountyState &&
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <span style={{ color: '#999897' }}>County / state</span>
              <span>{order.invoiceCountyState}</span>
            </div>}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Country</span>
            <span>{order.invoiceCountry}</span>
          </div>

        </div>

        {this.state.modalOpened &&
          <InvoicingSettingsModal 
            order={order}
            onSubmit={this.onSubmit}
            onClose={this.onToggleModal}
          />}
      </React.Fragment>
    );
  }

  private onToggleModal() {
    this.setState({
      modalOpened: !this.state.modalOpened,
    });
  }

  private async onSubmit(data: any) {
    await this.props.onUpdate(data);
    this.onToggleModal();
  }
}

export default InvoicingSettings;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/InvoicingSettings/InvoicingSettings.tsx